<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.ROOM_TYPE' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.ROOM_TYPE' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="roomTypeForm">
        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.ROOM_TYPE' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'ENTITY.ROOM_TYPE' | translate }}" formControlName="name" appCapitalizeFirstLetter>
                    <mat-error *ngIf="roomTypeForm.get('name')?.hasError('required') && 
                    (roomTypeForm.get('name')?.dirty || roomTypeForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="roomTypeForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.MAX_BEDS' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.MAX_BEDS' | translate }}" formControlName="maxBeds">
                    <mat-error *ngIf="roomTypeForm.get('maxBeds')?.hasError('required') && 
                    (roomTypeForm.get('maxBeds')?.dirty || roomTypeForm.get('maxBeds')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="roomTypeForm.get('maxBeds')?.hasError('min')">
                        {{ 'REQUIRED.MINIMUM_1' | translate }}
                    </mat-error>
                    <mat-error *ngIf="roomTypeForm.get('maxBeds')?.hasError('max')">
                        {{ 'REQUIRED.MAXIMUM100' | translate }}
                    </mat-error>
                    <mat-error *ngIf="roomTypeForm.get('maxBeds')?.hasError('invalidNumber')">
                        {{ 'REQUIRED.ONLY_NUMBER' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <!-- dropdown ward -->
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.WARD' | translate }}</mat-label>
                    <mat-select formControlName="wardId">
                        @for (ward of wardddl; track ward) {
                        <mat-option [value]="ward.id">{{ward.name}}</mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="roomTypeForm.get('wardId')?.hasError('required')">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.BILL_CHARGE' | translate }}</mat-label>
                    <mat-select formControlName="chargeId">
                        <mat-option *appHasRole="ROLE_GROUPS.AllTenant" (click)="addBillCharge()">
                            <span class="f-w-600 f-s-15">{{ 'LABEL.ADD_LABEL' | translate }} New {{ 'ENTITY.BILL_CHARGE'
                                | translate }}</span>
                        </mat-option>
                        @for (billcharge of billchargeslist; track billcharge) {
                        <mat-option [value]="billcharge.id">
                            <span class="f-s-15">{{ billcharge.name }}</span>
                            <span class="charge-amount f-s-14 f-w-600 m-l-20">({{billcharge.childValue|
                                currency:'INR'}})</span>
                        </mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="roomTypeForm.get('chargeId')?.hasError('required') && 
                    (roomTypeForm.get('chargeId')?.dirty || roomTypeForm.get('chargeId')?.touched)">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-label><strong>{{'LABEL.IS_ACTIVE' | translate }}:</strong></mat-label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox class="example-margin" color="primary" formControlName="isActive"></mat-checkbox>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button type="button" class="m-r-5" (click)="onCloseDialog()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </button>

            <button mat-flat-button type="button" color="primary" class="m-l-4" (click)="onUpdateRoomType()"
                *ngIf="isEdit" [disabled]="roomTypeForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}
            </button>

            <button mat-flat-button type="button" color="primary" class="m-l-4" (click)="onAddRoomType()"
                *ngIf="!isEdit" [disabled]="roomTypeForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}
            </button>
        </div>
    </div>
</mat-dialog-actions>